export default __webpack_public_path__ + "static/media/seller_credit_note.3610940e.xlsx";